module.exports = new __parcel__URL__("shop_machines_laser_cannon.5a6afcd7.png").toString();